import styled from 'styled-components'
import EditorPreview from 'ui/components/forms/EditorPreview'

export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const DescriptionTitle = styled.div`
  color: var(--t-template-description-title-color);
`

export const EditorPreviewStyled = styled(EditorPreview)`
  margin-bottom: 0;
`
